import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { ShopComponent } from './shop/shop.component';
import { PagesComponent } from './pages/pages.component';
import { ElementsComponent } from './elements/elements.component';
import { AppComponent } from './app.component';
import { LandscreenComponent } from './landscreen/landscreen.component';
import { NewlandscreenComponent } from './newlandscreen/newlandscreen.component';
import { AuthGuardGuard } from './shared/services/auth-guard.guard';
import { NqrmgmNavigaionComponent } from './nqrmgm-navigaion/nqrmgm-navigaion.component';

const routes: Routes = [
  {
    path: "",
    component: AppComponent,
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'shop',
    component: ShopComponent,
   
   
      // children: [
      //     {
      //         path: ':id',              
      //         component: ShopComponent,
      //     },
      //     {
      //       path: 'navimart',              
      //       component: ShopComponent,
      //   }
      // ]
     loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule),
     canActivate: [AuthGuardGuard],
  },
  { 
    path: 'pages',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) 
  },
  {
    path: 'aboutus',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) 
  },

  {
    path: 'shipping',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) 
  },
  {
    path: 'privacypolicy',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) 
  },
  {
    path: 'termsAndConditions',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) 
  },
  { 
    path: 'elements', 
    component: ElementsComponent,
    loadChildren: () => import('./elements/elements.module').then(m => m.ElementsModule) 
  },
  {
    path: "landscreen",
    component: NewlandscreenComponent
  },
  {
    path: "nqrmgm/:id",
    component: NqrmgmNavigaionComponent,
    canActivate: [AuthGuardGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
  initialNavigation: 'enabled',
    useHash: false,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
